export default "__VITE_ASSET__Zo17pCf$__"